import React from 'react';
import Image from 'next/image';
import { IBanner } from '@/services/types';
import { HeroTitle } from './HeroTitle';
import { HeroButtons } from './HeroButtons';
import { HeroMetrics } from './HeroMetrics';
import { HeroNavigation } from './HeroNavigation';

interface HeroSlideContentProps {
  banner: IBanner;
  totalSlides: number;
  currentSlide: number;
  onSlideChange: (index: number) => void;
  stripHtml: (html: string) => string;
}

export const HeroSlideContent: React.FC<HeroSlideContentProps> = ({
  banner,
  totalSlides,
  currentSlide,
  onSlideChange,
  stripHtml,
}) => {
  return (
    <div className="container flex flex-col lg:flex-row justify-between items-center h-full px-4 sm:px-6 gap-8">
      {/* Texto e Botões */}
      <div className="h-full flex flex-col justify-start lg:justify-center items-center lg:items-start gap-3 sm:gap-4 lg:gap-6 w-full lg:w-[700px] text-center lg:text-left pt-32 sm:pt-36 md:pt-40 lg:py-0 pb-4 sm:pb-6">
        {/* Título */}
        <HeroTitle title={banner.title} highlightPhrase={banner.highlight_title} />

        {/* Descrição */}
        <p className="font-light font-sans text-base sm:text-lg lg:text-[19px] leading-6 sm:leading-7 text-[#4A4A4A] max-w-lg mx-auto lg:mx-0">
          {stripHtml(banner.description || '')}
        </p>


        {/* Botões */}
        <HeroButtons buttons={banner.button || []} />

        {/* Seção de Métricas */}
        <HeroMetrics metrics={banner.metricas} />

        {/* Imagem do Banner - Mobile (pequena) */}
        <div className="lg:hidden w-full flex justify-end absolute top-86 -right-10 z-0 pr-2">
          <div className="relative w-64 h-64 ">
            <Image
              src={banner.image?.url || '/placeholder-banner.png'}
              alt={banner.title}
              width={226}
              height={226}
              className="object-contain z-0"
              priority
            />
          </div>
        </div>

        {/* Navegação por pontos - Mobile */}
        <HeroNavigation
          totalSlides={totalSlides}
          currentSlide={currentSlide}
          onSlideChange={onSlideChange}
          variant="mobile"
        />
      </div>

      {/* Imagem do Banner - Desktop (lado direito) */}
      <div className="hidden lg:flex sm:-mt-42 lg:-mt-0 xl:mt-8 lg:w-1/2 h-full items-end justify-end relative">
        <div className="relative w-full h-full flex items-end mb-0 lg:mb-18">
          <Image
            src={banner.image?.url || '/placeholder-banner.png'}
            alt={banner.title}
            width={900}
            height={900}
            className="object-contain object-bottom w-full h-[600px] sm:h-[400px] lg:h-[700px]"
            priority
          />
        </div>
      </div>
    </div>
  );
};
